import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=58155f05&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"
import style0 from "./Extension.vue?vue&type=style&index=0&id=58155f05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58155f05",
  null
  
)

export default component.exports